import {animate, state, style, transition, trigger} from '@angular/core';

export const animation = trigger('slideInOutAnimation', [

  state('*', style({

  })),
  transition(':enter', [
    style({
      transform: 'translateY(20%)',
      opacity: 0,
    }),
    animate('.5s ease-in-out', style({
      transform: 'translateY(0)',
      opacity: 1,
    }))
  ]),
  transition(':leave', [
    animate('.5s ease-in-out', style({
      transform: 'translateY(5%)',
      opacity: 0,
    }))
  ])
]);



// WEBPACK FOOTER //
// ./src/app/shared/animations/animations.ts